import { render, staticRenderFns } from "./GoalCard.vue?vue&type=template&id=1a9b4439&scoped=true&"
import script from "./GoalCard.vue?vue&type=script&lang=js&"
export * from "./GoalCard.vue?vue&type=script&lang=js&"
import style0 from "./GoalCard.vue?vue&type=style&index=0&id=1a9b4439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b4439",
  null
  
)

export default component.exports